import { createHttpClient } from '@aspid/api-client';

import { PUBLIC_URL } from '@constants';

import { baseUrlBuilder } from './baseUrlBuilder';

/**
 * Транспорт приложения. Настройки (сессия, CSRF, сериализация массивов в
 * query) живут в `@aspid/api-client` и одинаковы для всех приложений —
 * приложение задаёт только свой базовый URL.
 */
export const HttpClientFactory = () =>
  createHttpClient({ baseURL: baseUrlBuilder(PUBLIC_URL) });

export const HttpClient = HttpClientFactory();
